<template>
    <div class="w-full flex flex-column gap-2">
        <div v-if="show_list" class="w-full mb-2">
            <div v-for="code in bank_codes" class="inline-block relative mb-0 p-1 border-round-md surface-0 mr-2 mb-2" style="line-height:15px">
                <img :src="getBankImage(code)" class="absolute top-0 mt-1 left-0 ml-1" style="max-width: 15px;">
                <span class="text-xs inline-block white-space-nowrap float-left m-0 pl-4" >{{ getBankTitle(code) }}</span>
            </div>
        </div>
        <div class="w-full">
            <Button label="Изменить" @click="displayPopup=true" :badge="getLength(bank_codes)"
                size="small" icon="pi pi-pencil" iconPos="left" severity="secondary"/>
        </div>
    </div>
    
    <!--ИЗМЕНЕНИЕ КОДОВ БАНКОВ-->
    <Dialog class="w-full h-full border-none border-noround" modal v-model:visible="displayPopup"
        :style="{ width: '100%!important', height: '100%!important', margin: '0!important', padding: '0!important' }">

        <template #header>
            <div class="flex flex-row justify-content-between align-items-center">
                <span class="text-lg font-semibold">Банки</span>
            </div>
        </template>

        <div class="w-full relative mb-3">
            <Chip v-for="code in selectedBanks"  class="p-0 px-2 m-1">
                <div v-if="getBankImage(code)" class="flex">
                    <AvatarGroup>
                        <Avatar :image="`/images/svg/pays/${getTypeByCode(code)}.svg`" class="surface-0" shape="circle"/>
                        <Avatar :image="getBankImage(code)" class="surface-0" shape="circle"/>
                    </AvatarGroup>
                </div>
                <span v-else class="bg-primary text-primary-contrast rounded-full w-8 h-8 flex items-center justify-center">B</span>
                <span class="text-xs font-medium">{{ getBankTitle(code) }}</span>
                <i class="pi pi-times cursor-pointer text-400" @click="remove(code)"></i>
            </Chip>
        </div>

        <Button label="Очистить" @click="clear" size="small" icon="pi pi-times" iconPos="right" severity="danger" outlined/>

        <DataTable v-if='banks' :value="banks" responsiveLayout="scroll" ref="dt" dataKey="id"
                        :rows="100" :rowsPerPageOptions="[5, 10, 20, 50, 100]" :totalRecords="totalRecords"
                        @page="onPage($event)" @sort="onSort($event)" :loading="loading" 
                        @filter="onFilter($event)" v-model:filters="filters" filterDisplay="menu" :globalFilterFields="['type']" >

            <Column field="code" header="">
                <template #header>
                    <span class="text-xs">Имя</span>
                </template>
                <template #body="{ data }">
                    <div v-if="data.code" class="flex flex-row text-sm gap-2">
                        <AvatarGroup>
                            <Avatar :image="`/images/svg/pays/${data.type}.svg`" class="w-full surface-0" shape="circle"/>
                            <Avatar :image="getBankImage(data.code)" class="w-full surface-0" shape="circle"/>
                        </AvatarGroup>
                        <div class="w-full flex flex-row align-items-center gap-2 overflow-hidden">
                            <span class="white-space-nowrap" style="text-overflow:ellipsis;">
                                {{ getBankTitle(data.code) }}
                            </span>
                            <span class="white-space-nowrap" >({{data.code}})</span>
                        </div>
                    </div>
                </template>
            </Column>

            <Column field="type" :showFilterMenu="false" :showFilterMatchModes="false">
                <template #header>
                    <span class="text-xs">Тип</span>
                </template>
                <template #body="{ data }">
                    <span class="text-white font-medium text-xs p-1 border-round-md surface-500">
                        {{ getType(data.type) }}
                    </span>
                </template>
            </Column>

            <Column field="currency_code" header="" :showFilterMenu="true" :showFilterMatchModes="false">
                <template #header>
                    <span class="text-xs">Валюта</span>
                </template>
                <template #filter="{ filterModel, filterCallback }">
                    <Select v-model="filterModel.value" @change="filterCallback()" :options="currencies" optionLabel="code" optionValue="code" placeholder="Все" class="p-column-filter uppercase" :showClear="true" filter>
                    <template #option="slotProps">
                        <div class="inline-block py-1 px-2 text-xs border-round-md font-semibold surface-300 cursor-pointer font-medium align-items-center" >
                            <span class="flex uppercase">{{slotProps.option.code}}</span>
                        </div>
                    </template>
                </Select>
                </template>
                
                <template #body="{ data }">
                    <div v-if="data.currency_code" class="flex text-xs align-items-center w-7rem">
                        <img :src="getCurImage(data.currency_code)" class="mr-2 w-3 border-200 border-1 border-circle" style="max-width: 22px;" />
                        <span class="uppercase">{{ data.currency_code }}</span>
                    </div>
                </template>
            </Column>

            <Column field="code" header="">
                <template #header>
                    <span class="text-xs">+</span>
                </template>
                <template #body="{ data }">
                    <div v-if="data.code" class="flex flex-row text-sm m-0">
                        <Button @click="(selectedBanks.includes(data.code)) ? remove(data.code) : add(data.code)"
                            class="border-0 border-round-md" size="small"
                            :icon="(selectedBanks.includes(data.code)) ? 'pi pi-minus' : 'pi pi-plus'"
                            :class="(selectedBanks.includes(data.code)) ? 'bg-orange-400' : 'primary'"/>
                    </div>
                </template>
            </Column>

        </DataTable>

        <template #footer>
            <div class="pt-3" :class="(screenSize=='xs' || screenSize=='sm') ? 'w-full' : ''">
                <Button label="Сохранить" @click='save()' :loading="loading" :disabled="loading" 
                    :class="(screenSize=='xs' || screenSize=='sm') ? 'w-full' : ''" />
            </div>  
        </template>
    </Dialog>
    
</template>

<script>
import Connect from '@/assets/js/Connect'
import Helper from '@/assets/js/Helper'
import { BankList } from '@/assets/js/classes/PaymentSystem.js'
import { CurrencyList } from '@/assets/js/classes/Currency.js'

export default {
    props: {
        id: {type: String, default: ''},    // в качестве id передаем id любой сущности, например id курса
        bank_codes: {type: Array, default: () => []},
        type: {type: String, default: ''},  // тип get | send
        close: {type: Boolean, default: false},
        loading: {type: Boolean, default: false},
        show_list: {type: Boolean, default: false},
        filter: {
            type: Object,
            default: () => null
        },
    },
    data() {
        return {
            currencies: [],
            banks: [],
            displayPopup: false,
            selectedBanks: [],
            lazyParams: {},
            filters: {
                currency_code: {
                    value: (this.filter && this.filter.currency_code) ? this.filter.currency_code : '',
                    matchMode: 'contains'
                },
            },
            totalRecords: 0,
            types: [
                { label: 'Карта', value: 'card'},
                { label: 'Биржа', value: 'stock'},
                { label: 'СБП', value: 'sbp'},
                { label: 'Банкомат', value: 'atm'},
                { label: 'Курьер', value: 'courier'},
                { label: 'SWIFT', value: 'swift'},
                { label: 'Офис', value: 'office'},
                { label: 'Крипта', value: 'crypto'},
            ],
        }
    },
    watch: {
        close(val){
            if(val) this.displayPopup = false
        },
    },
    computed: {
        lang() { return (this.$i18n.locale) ? this.$i18n.locale : 'ru' },
        screenSize() { return this.$store.getters.StateScreenSize },
    },
    methods: {
        getLength(arr){
            if(!arr || !arr.length) return 0
            return arr.length
        },
        getBankTitle(code){
            let bankObj = new BankList()
            bankObj.items = this.banks
            const bankCode = bankObj.GetTitle(code, this.lang)
            return (bankCode) ? bankCode : code
        },
        getBankImage(code){
            let bankObj = new BankList()
            bankObj.items = this.banks
            const bankCode = bankObj.GetImage(code)
            return (bankCode) ? bankCode : code
        },
        getCurImage(code){
            return this.helper.GetCurrencyImage(code, this.currencies)
        },
        getType(type){
            const t = this.types.find(t=>t.value==type)
            return (t) ? t.label : type
        },
        add(code){
            if(!code) return
            this.selectedBanks.push(code)
            this.selectedBanks = [...new Set(this.selectedBanks)]
        },
        remove(code){
            if(!code) return
            const newArr = this.selectedBanks.filter(item => item !== code)
            this.selectedBanks = newArr
        },
        clear(){
            this.selectedBanks = []
        },
        getTypeByCode(code){
            if(!code) return null
            const bank = this.banks.find(bank => bank.code === code)
            if(bank && bank.type) return bank.type
            return null
        },
        async LoadBanks(){
            this.banks = await BankList.GetList(this.$store).then(res => res)
        },
        async LoadCurrencies(){
            this.currencies = await CurrencyList.GetList(this.$store).then(r=>r)
        },
        onFilter(event) {
            this.lazyParams.filters = this.filters
        },
        async save(){
            this.$emit('update', {
                id: this.id,
                bank_codes: this.selectedBanks,
                type: this.type
            })
        }
    },
    async beforeCreate(){
        this.connect = new Connect()
        this.helper = new Helper()
    },
    mounted(){
        this.lazyParams = {
            first: 0,
            rows: 10,
            sortField: null,
            sortOrder: null,
            filters: this.filters
        };
    },
    async created(){
        await this.LoadBanks().then(r=>r)
        await this.LoadCurrencies().then(r=>r)
        this.selectedBanks = this.bank_codes
    }
}
</script>